import { render } from "./AppAddToDo.vue?vue&type=template&id=f2960c88&ts=true"
import script from "./AppAddToDo.vue?vue&type=script&lang=ts"
export * from "./AppAddToDo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__